import { Button } from '@/lib/components/ui/button';
import { XIcon } from 'lucide-react';

interface Props {
  onClick: () => void;
}
export const CloseButton = ({ onClick }: Props) => {
  return (
    <Button onClick={onClick} variant='ghost' size='md' className='icon text-button-primary-outline-default'>
      <XIcon size={50} />
    </Button>
  );
};
